import { api } from '@/core/api/';

const baseUrl = 'api/message';

export const getRoles = () => api.get(`${baseUrl}/roles`);

export const getApplications = () => api.get(`${baseUrl}/applications`);

export const getLocations = (type = 'MessageLocation') =>
  api.get('api/code/codesbytype', {
    params: {
      type,
    },
  });

export const getUsersFromRole = (roleId) =>
  api.get(`${baseUrl}/usersfromrole`, {
    params: {
      roleId,
    },
  });

export const getMessageDetails = (id) => {
  return api.get(`${baseUrl}/details/${id}`);
};

export const saveMessage = (data) => {
  return api.post(`${baseUrl}/save`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateMessage = (data) => {
  return api.put(`${baseUrl}/edit`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteMessage = (id) => {
  return api.delete(`${baseUrl}/delete/${id}`);
};
